export default __webpack_public_path__ + "static/AP_logo-b52cc4e80c9b3d81ec0627a931b398fb.jpg";